import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import slider1 from "../../images/slider-1.jpg";
import slider2 from "../../images/slider-2.jpg";
import slider3 from "../../images/slider-3.jpg";
import slider4 from "../../images/slider-4.jpg";

const Section1 = () => {
  const slider = [
    { src: slider1, alt: "Slider 1" },
    { src: slider2, alt: "Slider 2" },
    { src: slider3, alt: "Slider 3" },
    { src: slider4, alt: "Slider 4" },
  ];
  return (
    <section className="hero split bg-light">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]} // Add modules here
        spaceBetween={30}
        slidesPerView={1}
        navigation
        // pagination={{ clickable: true }}
        autoplay={{ delay: 4500 }}
        loop={true}
      >
        {slider.map((slide) => {
          return (
            <SwiperSlide>
              <img src={slide.src} alt={slide.alt} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Section1;
